import { render } from "./LabCreate2NewPropack.vue?vue&type=template&id=70437168"
import script from "./LabCreate2NewPropack.vue?vue&type=script&lang=js"
export * from "./LabCreate2NewPropack.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__